import {
	BankSession,
	GetAllBankSessionsResponseDto,
} from '#modules/Bank/Bank.types'
import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../../fluxStandardAction'
import { BankError } from '#modules/Bank/Bank.types'

export type BankSessionClearErrorsAction = {
	type: 'transactionClientApp/bankSessions/clearErrors'
}
export type GetAllBankSessionsAction = FluxStandardAction<
	'transactionClientApp/bankSessions/getAll',
	null
>
export type GetAllBankSessionsSucceededAction = FluxStandardAction<
	'transactionClientApp/bankSessions/getAllSuccess',
	GetAllBankSessionsResponseDto
>
export type GetAllBankSessionsFailedAction =
	FluxStandardFailureAction<'transactionClientApp/bankSessions/getAllFailure'>
export type CreateBankSessionAction = FluxStandardAction<
	'transactionClientApp/bankSessions/create',
	{ bankId: number; consentCode: string; authUrl?: string }
>
export type CreateBankSessionSucceededAction = FluxStandardAction<
	'transactionClientApp/bankSessions/createSucceeded',
	BankSession
>

export type CreateBankSessionFailedAction =
	FluxStandardFailureAction<'transactionClientApp/bankSessions/createFailed'>

export type BankSessionsAction =
	| GetAllBankSessionsAction
	| GetAllBankSessionsSucceededAction
	| GetAllBankSessionsFailedAction
	| BankSessionClearErrorsAction
	| CreateBankSessionAction
	| CreateBankSessionSucceededAction
	| CreateBankSessionFailedAction

export const getAllBankSessions = (): GetAllBankSessionsAction => {
	return {
		type: 'transactionClientApp/bankSessions/getAll',
		payload: null,
	}
}

export const getAllBankSessionsSucceeded = (
	response: GetAllBankSessionsResponseDto,
): GetAllBankSessionsSucceededAction => {
	return {
		type: 'transactionClientApp/bankSessions/getAllSuccess',
		payload: response,
	}
}

export const getAllBankSessionsFailed = (
	error: BankError,
): GetAllBankSessionsFailedAction => {
	return {
		type: 'transactionClientApp/bankSessions/getAllFailure',
		payload: error,
		error: true,
	}
}

export function clearErrors(): BankSessionClearErrorsAction {
	return {
		type: 'transactionClientApp/bankSessions/clearErrors',
	}
}

export function createBankSession(
	bankId: number,
	consentCode: string,
	authUrl?: string,
): CreateBankSessionAction {
	return {
		type: 'transactionClientApp/bankSessions/create',
		payload: {
			bankId,
			consentCode,
			authUrl,
		},
	}
}

export function createBankSessionSucceeded(
	bankSession: BankSession,
): CreateBankSessionSucceededAction {
	return {
		type: 'transactionClientApp/bankSessions/createSucceeded',
		payload: bankSession,
	}
}

export function createBankSessionFailed(
	createBankSessionError: BankError,
): CreateBankSessionFailedAction {
	return {
		type: 'transactionClientApp/bankSessions/createFailed',
		payload: createBankSessionError,
		error: true,
	}
}
